import type { BrandSlots } from "@cfg/brand-sdk";

const Logo: BrandSlots["Logo"] = ({ brand }) => (
  <span className="bb-wordmark" aria-label={brand.name}>
    <span className="bb-wordmark-brick" aria-hidden />
    {brand.name}
  </span>
);

const Header: BrandSlots["Header"] = ({ brand, nav, user, onSignIn, onSignOut }) => (
  <header className="bb-header">
    <a className="bb-header-brand" href="/">
      <Logo brand={brand} />
      <span className="bb-stamp">rev. live</span>
    </a>
    <nav className="bb-nav" aria-label="Primary">
      {nav.map((n) => (
        <a key={n.href} href={n.href} className={`bb-nav-link${n.active ? " is-active" : ""}`} aria-current={n.active ? "page" : undefined}>
          {n.label}
        </a>
      ))}
      {user ? (
        <button type="button" className="bb-nav-link bb-nav-user" onClick={onSignOut} title={user.email}>
          {user.picture ? <img src={user.picture} alt="" width={18} height={18} /> : null}
          {user.name ?? "Account"} · sign out
        </button>
      ) : (
        <button type="button" className="bb-nav-link" onClick={onSignIn}>
          Sign in
        </button>
      )}
    </nav>
  </header>
);

const Footer: BrandSlots["Footer"] = ({ brand }) => (
  <footer className="bb-footer">
    <span>{brand.name}</span>
    <span className="bb-footer-note">Tolerances are stated, not guessed. If it doesn’t fit like an original piece, it doesn’t ship.</span>
    {brand.fitTags.disclaimer && <span className="bb-footer-note bb-footer-legal">{brand.fitTags.disclaimer}</span>}
  </footer>
);

const CatalogCard: BrandSlots["CatalogCard"] = ({ entry, children }) => (
  <a className="bb-card" href={entry.href}>
    <span className="bb-card-tape" aria-hidden />
    <div className="bb-card-preview">
      {children ?? (entry.thumbnailUrl ? <img src={entry.thumbnailUrl} alt="" loading="lazy" /> : <span className="bb-card-placeholder">{entry.title.slice(0, 2)}</span>)}
    </div>
    <div className="bb-card-body">
      <h3 className="bb-card-title">{entry.title}</h3>
      {entry.description && <p className="bb-card-desc">{entry.description}</p>}
      <div className="bb-card-meta">
        <span className="bb-stamp dim">v{entry.version}</span>
        {entry.tags.filter((t) => !t.startsWith("legacy:")).slice(0, 3).map((t) => (
          <span key={t} className="bb-tag">
            {t}
          </span>
        ))}
      </div>
    </div>
  </a>
);

const EmptyState: BrandSlots["EmptyState"] = ({ title, body, action }) => (
  <div className="bb-empty">
    <h2>{title}</h2>
    {body && <p>{body}</p>}
    {action}
  </div>
);

const ConfiguratorFrame: BrandSlots["ConfiguratorFrame"] = ({ children, aside }) => (
  <div className="bb-frame">
    <div className="bb-frame-main">{children}</div>
    {aside && <aside className="bb-frame-aside">{aside}</aside>}
  </div>
);

export const slots: Partial<BrandSlots> = { Logo, Header, Footer, CatalogCard, EmptyState, ConfiguratorFrame };
